interface TokenToStorage {
  code: number;
  token: string;
  establishmentId?: string;
}

const ACCESS_TOKENS_ID = "access_tokens";
const REFRESH_TOKENS_ID = "refreshTokens";

const getAccessTokens = (): TokenToStorage[] => {
  const tokensJson = localStorage.getItem(ACCESS_TOKENS_ID);
  let tokens: TokenToStorage[] = [];
  if (tokensJson) {
    tokens = JSON.parse(tokensJson) as TokenToStorage[];
  }
  return tokens;
};

const getRefreshToken = () => {
  return localStorage.getItem(REFRESH_TOKENS_ID);
};

const saveAccessToken = (
  accessToken: string,
  establishmentcode: string,
  establishmentId?: string
) => {
  const findIndex = getAccessTokens().findIndex(
    (t) => t.code === +establishmentcode
  );

  if (findIndex !== -1) {
    const newTokens = getAccessTokens().map((t) => {
      if (t.code === +establishmentcode) {
        t.token = accessToken;
      }
      return t;
    });
    localStorage.setItem(ACCESS_TOKENS_ID, JSON.stringify(newTokens));

    return;
  }

  const tokens: TokenToStorage[] = [
    ...getAccessTokens(),
    {
      code: +establishmentcode,
      token: accessToken,
      establishmentId: establishmentId,
    },
  ];

  localStorage.setItem(ACCESS_TOKENS_ID, JSON.stringify(tokens));
};

const saveRefreshToken = (resfreshToken: string) => {
  localStorage.setItem(REFRESH_TOKENS_ID, resfreshToken);
};

const removeRefreshToken = () => {
  localStorage.removeItem(REFRESH_TOKENS_ID);
};

const removeAccessToken = (code: number) => {
  const tokens: TokenToStorage[] = getAccessTokens().filter(
    (v) => v.code !== code
  );
  localStorage.setItem(ACCESS_TOKENS_ID, JSON.stringify(tokens));
};

const getTokens = () => ({
  refreshToken: getRefreshToken(),
  access_tokens: getAccessTokens(),
});

const saveTokens = (
  token: string,
  refreshToken: string,
  establishmentIndex: string,
  establishmentId?: string
) => {
  saveAccessToken(token, establishmentIndex, establishmentId);
  saveRefreshToken(refreshToken);
};

const removeAllTokens = () => {
  localStorage.removeItem(REFRESH_TOKENS_ID);
  localStorage.removeItem(ACCESS_TOKENS_ID);
};

const removeToken = (index: number) => {
  removeRefreshToken();
  removeAccessToken(index);
};

const hasAccessTokens = () => getAccessTokens().length > 0;

const hasRefreshTokens = () => !!getRefreshToken();

export const tokenService = {
  getTokens,
  removeToken,
  saveTokens,
  hasAccessTokens,
  hasRefreshTokens,
  removeAllTokens,
  getAccessTokens,
  removeAccessToken,
};
